export const CATEGORY_LABEL = {
    marketing_dnc: "Marketing DNC",
    technical: "Technical",
    manual_review: "Manual Review",
};

export const CATEGORY_TONE = {
    marketing_dnc: "bg-rose-100 text-rose-800 border-rose-200",
    technical: "bg-amber-100 text-amber-800 border-amber-200",
    manual_review: "bg-slate-100 text-slate-700 border-slate-200",
};

export const REASON_LABEL = {
    suppressed_marketing_dnc: "Marketing DNC",
    suppressed_technical: "Technical",
    suppressed_do_not_text: "Do-not-text flag",
    suppressed_opted_out: "Opted-out status",
    suppressed_sms_opt_out: "SMS opt-out",
};

const PT = { timeZone: "America/Los_Angeles", month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" };

export function fmtPT(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleString("en-US", PT);
}

export function CategoryBadge({ category }) {
    return (
        <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium ${CATEGORY_TONE[category] || "bg-gray-100"}`}
              data-testid={`category-badge-${category}`}>
            {CATEGORY_LABEL[category] || category}
        </span>
    );
}

export function SectionCard({ title, sub, children, testId }) {
    return (
        <section className="rounded-xl border border-border bg-white shadow-sm" data-testid={testId}>
            <header className="px-5 pt-4 pb-3 border-b border-border">
                <h3 className="text-base font-semibold">{title}</h3>
                {sub ? <p className="text-xs text-muted-foreground mt-0.5">{sub}</p> : null}
            </header>
            <div className="p-5">{children}</div>
        </section>
    );
}
